module.exports = __webpack_public_path__ + "static/media/performance_0002.21760cfe.JPG";